module.exports = __webpack_public_path__ + "img/restaurant-detail.b932b496.svg";